var debug = (location.hash=='#debug');
var beta = (location.hash=='#beta');
var Waveform = function(element, callback){
  // console.log('this.render(element, callback);', element)
  this.render(element, callback);
  return this;
};

Waveform.prototype = {
  canvas: null,
  ctx: null,
  width: 3000,
  widthEstimated: 0,
  aurora: null,
  height: 100,
  color: '#ffffff',
  highlight: '#cb1606',
  align: 'bottom',
  linear: false,
  animate: false,
  duration: 1,
  easing: 'swing',
  normalize: true,
  gradient: false,
  alpha: 5,
  smooth: 3,
  blocks: false,
  'data-url': null,
  artist_id: null,
  track_id: null,
  sampleData: [],
  position: 0,
  prevPosition: -1,
  maxPeak: 255,
  zero: 128,
  pattern1: null,
  pattern2: null,
  callback: false,
  redraw: function(e) {
    /*
    var x,w;
    if(this.prevPosition < this.position) {
      x = this.prevPosition;
      w = this.position - this.prevPosition;
    } else if(this.position < this.prevPosition) {
      x = this.position;
      w = this.prevPosition - this.position;
    }
    var f = Math.round(this.sampleData.length/this.width)+1;
    if(x > 0) { x--; if(w <= this.width-f) w+=f; } // Fix
    this.ctx.globalCompositeOperation = 'source-over';
    this.ctx.clearRect(x, 0, w, this.height);
    while(w--) { this.drawPeak(Math.round(this.sampleData.length/this.width*(x+w))); }
    */
    this.position = parseInt(this.canvas.getAttribute('position'), 10)
    this.drawImage();
    return this.position
  },
  setDefaultValues: function(element, callback) {
    var waveform = this;
    this.canvas = element;
    // var cssColor = $(this.canvas).css("color");
    this.color = this.color;
    this.setAttrs(['width','height','data-url','png-url','cm-url','data-track','id','color','highlight','align','animate','duration','easing','normalize','linear','smooth','position','gradient','blocks','aurora','alpha', 'pattern1']);
    if(this.linear=="false") this.linear = false;
    if(this.normalize=="false") this.normalize = false;
    if(this.gradient=="false") this.gradient = false;
    if(this.blocks) {
      this.blocks = this.blocks.split(',');
      this.blocks[0] = parseFloat(this.blocks[0]);
      this.blocks[1] = parseFloat(this.blocks[1]);
      this.blocks[2] = this.blocks[2]=="false" ? false : true;
    }
    this.smooth = parseInt(this.smooth);
    this.width = parseInt(this.width);
    this.height = parseInt(this.height);
    this.position = parseInt(this.position);
    this.ctx = this.canvas.getContext('2d');
    this.pattern1 = this.pattern1
    setpixelated(this.ctx);

    this.artist_id =  1;
    this.track_id =  1;
    this.callback = callback;
    this.loadSamples();
  },
  setAttrs: function(arr) {
    var i = arr.length;
    while(i--) { this[arr[i]] = this.attr(arr[i],this[arr[i]]) }
  },
  attr: function(attr, defaultSetting) {
    var attr = this.canvas.getAttribute(attr);
    return (attr != undefined) ? attr : defaultSetting;
  },
  loadSamples: function() {
    var waveform = this;
    var url = waveform['data-url'];
    var pngurl = waveform['png-url'];
    var cmurl = waveform['cm-url'];
    var data_track = waveform['data-track'];
    var data = null;
    var ext = url.substring(url.lastIndexOf('.'));
    var version = "?version=" + Math.floor(Math.random()*100000);
    url += version;
    //if(debug) console.log(waveform.artist_id, waveform.track_id);

    if(waveform.artist_id > 0 && waveform.track_id > 0) {

      var samples = new Image();
      //samples.setAttribute('crossorigin', 'anonymous');
      samples.onload = function() {
        //if(debug) {
        new LogoMemory(this.src, function() {
          waveform.sampleData = this.samples;
          waveform.draw(function(){
            waveform.show();
          });
        });
        ext = null;
        removeLocal(url);
        //}
      }
      samples.onerror = function() {

        try {
          if(ext=='.png'&&waveform.aurora&&!$(waveform.aurora).find('.aurora').length) {
            new LogoMemory(url, function() {
              $(waveform.aurora).prepend($(new Aurora(this.colors)).fadeIn(2000));
            });
          }
          data = getLocal(url);
          if(data != "" && data != null && data != "null") {
            waveform.sampleData = data;
            waveform.draw(function(){
              waveform.show();
            });
          } else {
            ajx();
          }
        } catch(e) {
          ajx();
        }
        var converter = new Image();
        converter.src = '/saveDataAsImage.php?id='+waveform.track_id;
      }
      var filename = '/_/cache/waveform_png/'+waveform.artist_id+'/'+waveform.track_id+'.png';
      var filename = 'https://vowave.com/uploads/waveforms-png/PjsWjs/S1_7608_7WTco8FT.png?' + Math.floor(Math.random()*1000);
      //filename += version;
      samples.src = pngurl;
    }


    if(ext=='.js') {

      var ajx = function() {
        if (data_track != "") {
          waveform.sampleData = jQuery.parseJSON( data_track );
          waveform.draw(function(){
            waveform.show();
          });
        } else {

          $.ajax({
            url: url,
            dataType: 'json',
            async: false,
            cache:true,
            timeout:99999999999,
            success: function(data){
              if(data != "" && data != null && data != "null" && data.peaks != null && data.peaks.length) {
                //try { storeLocal(url,data) } catch(e) {}
                waveform.sampleData = data.peaks;
                waveform.draw(function(){
                  waveform.show();
                });
              }
            }
          });
        }
      }
    } else if(ext=='.png') {
      var ajx = function() {
        new LogoMemory(url, function() {
          waveform.sampleData = this.samples;
          waveform.draw(function(){
            waveform.show();
          });
        });
      }
    }
  },
  drawPeak: function(x) {

    /*
  if(debug) {

    var intVal = parseInt((this.sampleData[x] * 100) / this.maxPeak,10) / 100;
    var intSigmoid = 1/(1+Math.exp(intVal));
    var v = intSigmoid * this.height;


  } else {


  }
  */

    var v = this.linear ? parseInt(this.sampleData[x] / (this.normalize ? this.maxPeak : 255) * this.height) : Math.pow(this.height + this.zero, this.sampleData[x] / (this.normalize ? this.maxPeak : 255));


    //var v = ((Math.log(this.sampleData[x]) / Math.log(255)) * 255);

    //if(debug) var v = ((Math.log(this.sampleData[x]) / Math.log(255)) * this.height);

    if(this.linear) v = v > this.height + this.zero ? this.height + this.zero : v - this.zero <= 0 ? this.zero + 1 : v;
    var y = this.height - v;
    var p = this.linear ? this.height - y * 2 : v - this.zero;
    var t = this.width / this.sampleData.length;
    var top, bottom;
    switch(this.align) {
      case "bottom":
        top = this.linear ? y * 2 : y + this.zero;
        bottom = this.height;
        break;
      case "top":
        top = 0;
        bottom = this.linear ? v - y : p;
        break;
      default:
        top = this.linear ? y : (y + this.zero) / 1.3;
        p = this.height - (top * 1.3);
        bottom = p;
        break;
    }
    // var color = $.color.parse(this.color)
    // color.a = this.alpha;
    let color = {r: 255, b: 255, g: 255, a: 1}
    let radius =  10
    this.ctx.fillStyle = this.gradient ? this.createGradient(color, 0, top, 0, bottom) : 'rgba('+color.r+','+color.g+','+color.b+','+color.a+')';
    //let fillStyle = this.gradient ? this.createGradient(color, 0, top, 0, bottom) : 'rgba('+color.r+','+color.g+','+color.b+','+color.a+')';
    // ctx.strokeRect(
    //   options.x+(options.radius*.5),
    //   options.y+(options.radius*.5),
    //   options.width-options.radius,
    //   options.height-options.radius
    // );
    //
    // ctx.fillRect(
    //   options.x+(options.radius*.5),
    //   options.y+(options.radius*.5),
    //   options.width-options.radius,
    //   options.height-options.radius
    // );
    if(v>1) {
      //this.ctx.strokeRect(Math.ceil(x*t) + (radius*0.5), top + (radius*0.5), Math.ceil(t) - (radius*0.5), p - (radius*0.5));
      // this.roundRect(this.ctx, Math.ceil(x*t), top, Math.ceil(t), p, {
      //   tl: 5,
      //   br: 5

      this.ctx.fillRect(Math.ceil(x*t), top, Math.ceil(t), p);
      // }, true, false)
    }
  },
  /**
   * Draws a rounded rectangle using the current state of the canvas.
   * If you omit the last three params, it will draw a rectangle
   * outline with a 5 pixel border radius
   * @param {CanvasRenderingContext2D} ctx
   * @param {Number} x The top left x coordinate
   * @param {Number} y The top left y coordinate
   * @param {Number} width The width of the rectangle
   * @param {Number} height The height of the rectangle
   * @param {Number} [radius = 5] The corner radius; It can also be an object
   *                 to specify different radii for corners
   * @param {Number} [radius.tl = 0] Top left
   * @param {Number} [radius.tr = 0] Top right
   * @param {Number} [radius.br = 0] Bottom right
   * @param {Number} [radius.bl = 0] Bottom left
   * @param {Boolean} [fill = false] Whether to fill the rectangle.
   * @param {Boolean} [stroke = true] Whether to stroke the rectangle.
   */
  roundRect(ctx, x, y, width, height, radius, fill, stroke) {
    if (typeof stroke == 'undefined') {
      stroke = true;
    }
    if (typeof radius === 'undefined') {
      radius = 5;
    }
    if (typeof radius === 'number') {
      radius = {tl: radius, tr: radius, br: radius, bl: radius};
    } else {
      var defaultRadius = {tl: 0, tr: 0, br: 0, bl: 0};
      for (var side in defaultRadius) {
        radius[side] = radius[side] || defaultRadius[side];
      }
    }
    ctx.beginPath();
    ctx.moveTo(x + radius.tl, y);
    ctx.lineTo(x + width - radius.tr, y);
    ctx.quadraticCurveTo(x + width, y, x + width, y + radius.tr);
    ctx.lineTo(x + width, y + height - radius.br);
    ctx.quadraticCurveTo(x + width, y + height, x + width - radius.br, y + height);
    ctx.lineTo(x + radius.bl, y + height);
    ctx.quadraticCurveTo(x, y + height, x, y + height - radius.bl);
    ctx.lineTo(x, y + radius.tl);
    ctx.quadraticCurveTo(x, y, x + radius.tl, y);
    ctx.closePath();
    if (fill) {
      ctx.fill();
    }
    if (stroke) {
      ctx.stroke();
    }

  },
  drawPeaks: function(callback) {
    var x = this.sampleData.length;
    while(x--) {
      this.drawPeak(x)
    }
    if(callback) callback();
  },
  drawImage: function() {
    var waveform = this;
    this.ctx.globalCompositeOperation = 'source-atop';
    setpixelated(this.ctx);

    if(this.pattern1) {
      this.loadImage(this.pattern1, function(pattern) {
        waveform.mapImage(pattern,0,0,waveform.position,waveform.height);
        if(waveform.pattern2) {
          waveform.loadImage(waveform.pattern2, function(pattern) {
            waveform.mapImage(pattern,waveform.position,0,waveform.width-waveform.position,waveform.height);
          });
        } else {
          waveform.mapColor(waveform.color,waveform.position,0,waveform.width-waveform.position,waveform.height);
        }
      });
    } else if(this.pattern2) {
      this.mapColor(this.highlight,0,0,this.position,this.height);
      this.loadImage(this.pattern2, function(pattern) {
        waveform.mapImage(pattern,waveform.position,0,waveform.width-waveform.position,waveform.height);
      });
    } else {
      this.mapColor(this.highlight,0,0,this.position,this.height, true);
      this.mapColor(this.color,this.position,0,this.width-this.position,this.height);
    }
  },
  hexToRgb(hex) {
    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result ? {
      r: parseInt(result[1], 16),
      g: parseInt(result[2], 16),
      b: parseInt(result[3], 16)
    } : null;
  },
  mapColor: function(color, x, y, w, h, animate) {
    let vm = this
    let steps = 10
    let opacity = 0
    let rgb = vm.hexToRgb(color)
    // var colorParsed = $.color.parse(color);
    // var colorDark = $.color.parse(color).scale('rgb', 0.9);
    if(animate) {
      let interval = setInterval(function () {
        opacity += 0.04
        vm.ctx.fillStyle = 'rgba('+rgb.r+', '+rgb.g+', '+rgb.b+', '+opacity+')';
        vm.ctx.fillRect(x, y, w, h);
        if(opacity*10>=steps) clearInterval(interval)
      }, 30)
    } else {
      vm.ctx.fillStyle = 'rgba('+rgb.r+', '+rgb.g+', '+rgb.b+', 1)';
      vm.ctx.fillRect(x, y, w, h);
    }

  },
  mapImage: function(img, x, y, w, h) {
    this.ctx.fillStyle = this.ctx.createPattern(img,"repeat");
    this.ctx.fillRect(x, y, w, h);
  },
  loadImage: function(url, callback) {
    var waveform = this;
    var showImage = function(e) {
      var canvas = document.createElement('canvas');
      var ctx = canvas.getContext('2d');
      var zoomX = waveform.width/waveform.canvas.getBoundingClientRect().width;
      var zoomY = waveform.height/waveform.canvas.getBoundingClientRect().height;
      canvas.width = e.target.width*zoomX;
      canvas.height = e.target.height*zoomY;
      ctx.drawImage(e.target,0,0,canvas.width,canvas.height);
      window[btoa(url)] = canvas;
      callback(canvas);
    };
    if(window[btoa(url)]==undefined) {
      var image = new Image();
      image.onload = showImage;
      image.src = url;
    } else {
      callback(window[btoa(url)]);
    }
  },
  draw: function(callback) {
    // var i = this.smooth;
    //
    // while(i--) {
    //   this.smoothData(i);
    // };

    // this.smoothData();
    if(this.blocks && this.blocks.length==3) this.addGaps(this.blocks[0],this.blocks[1],this.blocks[2]);
    this.maxPeak = Math.max.apply(null, this.sampleData);
    this.zero = this.linear ? 0 : Math.pow(this.height, 128 / this.maxPeak);
    if(this.color.substring(this.color.lastIndexOf('.')).match('.(png|jpg)')) {
      this.pattern2 = this.color;
      this.color = 'rgba(0,0,0,'+parseFloat(this.alpha)+')';
    }
    if(this.highlight.substring(this.highlight.lastIndexOf('.')).match('.(png|jpg)')) {
      this.pattern1 = this.highlight;
      this.highlight = 'rgba(0,0,0,'+parseFloat(this.alpha)+')';
    }

    this.ctx.globalCompositeOperation = 'source-over';
    this.clear();
    this.drawPeaks(callback);
    this.drawImage();
  },
  smoothData: function(_intDurchlauf) {
    /*
  var i = this.sampleData.length;
  var sampleDataCache = 0;
  while(i--) {

    if (i % 2 == 0)
    {
      if(this.sampleData[i-1]) {
        this.sampleData[i] = this.sampleData[i-1];
        this.sampleData[i] = (sampleDataCache+this.sampleData[i]) / 2;
        sampleDataCache = this.sampleData[i];
      }
    }
    else
    {
        this.sampleData[i] = sampleDataCache;
    }

  }
  */



    var i = this.sampleData.length;
    while(i--) {
      if(this.sampleData[i-1]) {
        this.sampleData[i] = this.sampleData[i-1] = (this.sampleData[i-1]+this.sampleData[i]) / 2;
      }


      var intValPercent = (this.sampleData[i] * 100) / 255;


      if(intValPercent <= 55) {
        if(_intDurchlauf > 1) {
          this.sampleData[i] = this.sampleData[i] + Math.round(this.sampleData[i]/20);
        } else {
          this.sampleData[i] = this.sampleData[i] + Math.round(this.sampleData[i]/40);
        }
      } else if((intValPercent > 55) && (intValPercent <= 75)) {

        this.sampleData[i] = this.sampleData[i] + Math.round(this.sampleData[i]/12);
      } else if((intValPercent >= 75) && (intValPercent <= 90)) {
        this.sampleData[i] = this.sampleData[i] + Math.round(this.sampleData[i]/20);
      }

      if(this.sampleData[i] > 255) {
        this.sampleData[i] = 255;
      }



    }
  },
  addGaps: function(a,b,c) {
    var zoom = this.width/(this.canvas.getBoundingClientRect().width || this.widthEstimated)
    // console.log(this.width, this.canvas.getBoundingClientRect().width)
    a*=zoom,b*=zoom;
    if(a>0) {
      var i = this.sampleData.length;
      var peaks = [];
      while(i--) {
        if(b>0) {
          if(i%(a+b)<b) {
            if(peaks.length&&c) {
              var sum = 0
              var avg=0
              var k=peaks.length
              for(let j in peaks)sum+=peaks[j];
              avg=Math.round(sum/k)||0;
              while(k--)this.sampleData[i+k+1]=avg;
              peaks = [];
            }
            this.sampleData[i] = 0;
          } else {
            if(c)peaks.push(this.sampleData[i]);
          }
        } else if(c) {
          peaks.push(this.sampleData[i]);
          if(!Math.round(i%a)&&peaks.length) {
            var sum=0
            var avg=0
            var k=peaks.length
            for(let j in peaks)sum+=peaks[j];
            avg=Math.round(sum/k)||0;
            while(k--)this.sampleData[i+k+1]=avg;
            peaks = [];
          }
        }
      }
    }
  },
  clear: function() {
    this.ctx.clearRect(0, 0, this.width, this.height);
  },
  show: function(){
    // var waveform = this;
    // if (this.animate!="false") {
      // $(this.canvas).css({
      //   'opacity': 1
      // });
    //   $(this.canvas).removeAttr('style');
    //   $(this.canvas).removeClass("queued").addClass("rendered");
    //   if(this.callback) window.requestAnimFrame(this.callback);
    // } else {
      // $(this.canvas).css({
      //   'opacity': 1
      // });
    //   $(this.canvas).removeAttr('style');
    //   $(this.canvas).removeClass("queued").addClass("rendered");
    //   if(this.callback) window.requestAnimFrame(this.callback);
    // }
    // if(location.hash=="#custom"&&$(this.canvas).parents("li").find(".fa-cogs").length==0) {
    //   $(this.canvas).parents("li").first().prepend($('<i onclick="showWaveformControls($(this).parent().find(\'.waveform\'))" class="fa fa-cogs" style="margin-top: 25px;opacity: 0.2;z-index: 1000;display: block;cursor: pointer;position: absolute;right: 10px;"></i>'));
    // }
  },
  createGradient: function(rgb,x1,t,x2,b) {
    var objGradient = this.ctx.createLinearGradient(x1, t, x2, b);
    var transparent = "rgba("+rgb.r+","+rgb.g+","+rgb.b+",0)";
    switch(this.align) {
      case "bottom":
        if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
          objGradient.addColorStop(0,  rgb);
          objGradient.addColorStop(1,  rgb);
        } else {
          objGradient.addColorStop(0, transparent);
          objGradient.addColorStop(0.2, "rgba("+rgb.r+","+rgb.g+","+rgb.b+",1)");
          objGradient.addColorStop(1,  "rgba("+rgb.r+","+rgb.g+","+rgb.b+",1)"); // rgb
        }
        break;
      case "top":
        objGradient.addColorStop(0, rgb);
        objGradient.addColorStop(0.8, "rgba("+rgb.r+","+rgb.g+","+rgb.b+",1)");
        objGradient.addColorStop(1, transparent);
        break;
      default:
        objGradient.addColorStop(0, transparent);
        objGradient.addColorStop(0.13, "rgba("+rgb.r+","+rgb.g+","+rgb.b+",0.7)");
        objGradient.addColorStop(0.28, "rgba("+rgb.r+","+rgb.g+","+rgb.b+",0.9)");
        objGradient.addColorStop(0.35, "rgba("+rgb.r+","+rgb.g+","+rgb.b+",0.96)");
        objGradient.addColorStop(0.5, rgb);
        objGradient.addColorStop(0.65, "rgba("+rgb.r+","+rgb.g+","+rgb.b+",0.96)");
        objGradient.addColorStop(0.72, "rgba("+rgb.r+","+rgb.g+","+rgb.b+",0.9)");
        objGradient.addColorStop(0.87, "rgba("+rgb.r+","+rgb.g+","+rgb.b+",0.7)");
        objGradient.addColorStop(1, transparent);
        break;
    }
    return objGradient;
  },
  setPosition: function(e, redraw) {
    // console.log(this.position)
    // var track = findTrack(parseInt($(e.target).data("trackid")));
    this.prevPosition = this.position;
    // this.position = track ? parseInt(track.position / pagePlayer.getDurationEstimate(track) * this.width) : 0;
    if(this.position>=this.width) this.position = 0;

    // $(this.canvas).attr('position', this.position);

    if(redraw) this.redraw(e);
  },
  setPos: function(pos, redraw) {
    this.position = Math.floor(pos)
    if(redraw) this.redraw();
  },
  render: function(element, callback){
    var _this = this;
    element.setAttribute("data-queued", '1')
    // $(element).css({'opacity': 0 })
    // var container = element.parents('li').first();
    // if(container.length) {
      // container.on("soundstart", function(e) {
      //   var track = findTrack($(e.target).data('trackid'));
      //   if(track) {
      //     setTimeout(function(){
      //       //
      //       track.setPosition(+container.data('position')|0);
      //     },1);
      //   }
      // });
      // container.on("soundposition", function(e) {
      //   _this.setPosition(e, true);
      //   $(e.target).data('position',+findTrack($(e.target).data('trackid')).position|0);
      //   storeLocal("currentTrack", {
      //     id: $(e.target).data('trackid'),
      //     mainid: $(e.target).data('mainid'),
      //     position: $(e.target).data('position')
      //   });
      //
      //   storeLocal("playing", true);
      //
      // });
      // container.on("soundstop", function(e) {
      //   _this.setPosition(e, true);
      //   removeLocal("currentTrack");
      //   removeLocal("playing");
      // });

      // try {
      //   uniqueEventHandlers(container.data("events"));
      // } catch(e) {
      // }

      // this.setPosition({target:container},false);
      // element.addEventListener('click', function(e){
        // var position = (e.clientX - $(this).offset().left) / $(this).width() * $(container).data('length') * 1000;
        // findTrack().setPosition(position);
        // $(container).data('position',+position|0);
      // });
    // }
    this.setDefaultValues(element, callback)
  }

}


/**
 * Unique Event Handlers
 */

function uniqueEventHandlers(events) {
  for(var i in events) {
    events[i] = uniqueEventHandler(events[i]);
  }
}

function uniqueEventHandler(event) {
  var j = 0,
    i = 1,
    l = event.length | 0;

  while ( i < l && event[i-1].handler.toString() !== event[i].handler.toString() ) {
    ++i;
  }

  if ( i < l ) {
    for ( j = i; i < l; ++i ) {
      if ( event[i-1].handler.toString() !== event[i].handler.toString() ) {
        event[j++].handler = event[i].handler;
      }
    }
    event.length = j;
  }

  return event;
}

/**
 * Require Javascript Plugins
 */

function require(src) {
  // if(!$('script[src="'+src+'"]')) {
  $('<script>').attr({
    type: 'text/javascript',
    src: src
  }).prependTo($('head'));
  // }
}

/**
 * Logo Memory
 */

var LogoMemory = function(src, callback) {
  this.src = src;
  this.callback = callback;
  this.init();
  return this;
}

LogoMemory.prototype = {
  src: null,
  mask: '/logo_mask.png',
  colors: [],
  samples: [],
  callback: null,
  init: function() {
    var _this = this;
    var data = new Image();
    data.onload = function(e) {
      var data = e.target;
      //var mask = new Image();
      _this.parse(data);
      if(_this.callback) _this.callback();
      /*
      mask.onload = function(e) {
        var mask = e.target;
      }
      mask.src = _this.mask;
      */
    }
    data.src = this.src;
  },
  data: function(img) {
    var canvas = document.createElement('canvas');
    canvas.width = img.naturalWidth;
    canvas.height = img.naturalHeight;
    var ctx = canvas.getContext('2d');
    ctx.drawImage(img, 0, 0);
    return ctx.getImageData(0, 0, canvas.width, canvas.height).data;
  },
  parse: function(data) {
    this.colors = [];
    this.samples = [];
    var data = this.data(data);
    //var mask = this.data(mask);
    var i = data.length / 4;
    var o =0;
    while(i--) {
      /*
      o++;
      if(o > 10) break;
      */
      if(this.samples.length < 3000) {
        this.samples.push(data[i*4],data[i*4+1],data[i*4+2]);
      }
    }
  }
}


/**
 * Aurora
 */

var Aurora = function(colors) {
  this.colors = colors;
  return this.init();
}

Aurora.prototype = {
  canvas: document.createElement('canvas'),
  width: 1000,
  height: 223,
  colors: [],
  dna: null,
  dnaSize: 5,
  init: function() {
    return this.buildAurora();
  },
  blur: function(data) {
    var i = data.length;
    while(i--) if(data[i + 4] != undefined && data[i - 4] != undefined) data[i] = data[i + 4] = data[i - 4] = (data[i + 4] + data[i - 4] + data[i]) / 3;
    return data;
  },
  buildAurora: function() {
    var ctx = this.canvas.getContext('2d');
    this.canvas.width = this.width;
    this.canvas.height = this.height;
    this.canvas.className = "aurora";
    ctx.drawImage(this.buildDNA(),0,0,this.dna.width,this.dna.height,0,this.canvas.height-this.dnaSize,this.canvas.width,this.dnaSize);
    ctx.drawImage(this.buildDNA(80),0,0,this.dna.width,this.dna.height,0,0,this.canvas.width,this.canvas.height-this.dnaSize);
    var objGradient = ctx.createLinearGradient(0, 0, 0, this.canvas.height-this.dnaSize);
    objGradient.addColorStop(0, 'rgba(0,0,0,0.9)');
    objGradient.addColorStop(1, 'rgba(0,0,0,0.1)');
    ctx.fillStyle = objGradient;
    ctx.fillRect(0, 0, this.canvas.width, this.canvas.height-this.dnaSize);
    ctx.fillRect(0, 0, this.canvas.width, this.canvas.height-this.dnaSize);
    return this.canvas;
  },
  buildDNA: function(blur) {
    this.dna = document.createElement('canvas');
    this.dna.width = this.colors.length / 4;
    this.dna.height = 1;
    var ctx = this.dna.getContext('2d');
    var pixel = ctx.getImageData(0, 0, this.dna.width, this.dna.height);
    while(blur--) { this.colors = this.blur(this.colors); }
    try {
      pixel.data.set(this.colors);
    } catch(e) {
      var i = pixel.data.length;
      while(i--) pixel.data[i] = this.colors[i];
    }
    ctx.putImageData(pixel, 0, 0);
    return this.dna;
  }
}


/**
 * Local Storage
 */

function getLocal(key) {
  var data = false;
  try {
    data = JSON.parse(localStorage.getItem(key));
    return data;
  } catch(e) {
    return false;
  }
}

function storeLocal(key, data) {
  try {
    localStorage.setItem(key,JSON.stringify(data));
    return true;
  } catch(e) {
    return false;
  }
}

function removeLocal(key) {
  try {
    localStorage.removeItem(key);
    return true;
  } catch(e) {
    return false;
  }
}

function dropLocal() {
  try {
    localStorage.clear();
    return true;
  } catch(e) {
    return false;
  }
}

/**
 * Get only visible Elements
 */

// $.fn.isOnScreen = function(){
//
//   var win = $(window);
//
//   var viewport = {
//     top : win.scrollTop(),
//     left : win.scrollLeft()
//   };
//   viewport.right = viewport.left + win.width();
//   viewport.bottom = viewport.top + win.height();
//
//   var bounds = this.offset();
//   bounds.right = bounds.left + this.outerWidth();
//   bounds.bottom = bounds.top + this.outerHeight();
//
//   return (!(viewport.right < bounds.left || viewport.left > bounds.right || viewport.bottom < bounds.top || viewport.top > bounds.bottom));
//
// };

/**
 * Better Intervals for more performance
 * requestAnim shim layer by Paul Irish
 */

window.requestAnimFrame = (function(){
  return  window.requestAnimationFrame       ||
    window.webkitRequestAnimationFrame ||
    window.mozRequestAnimationFrame    ||
    window.oRequestAnimationFrame      ||
    window.msRequestAnimationFrame     ||
    function(/* function */ callback, /* DOMElement */ element){
      window.setTimeout(callback, 10000 / 60);
    };
})();

window.setCustomInterval = function(callback) {
  window.requestAnimFrame(function(){setCustomInterval(callback)});
  callback();
}

// isScrolling = false;
//
// var scrolltimer;
// $(window).bind('scroll',function () {
//   isScrolling = true;
//   clearTimeout(scrolltimer);
//   scrolltimer = setTimeout( refreshScrolling , 150 );
// });
//
// var refreshScrolling = function () {
//   // do stuff
//   isScrolling = false;
// };


/**
 * Concrete Render Function
 */

function renderWaveform(canvas, callback) {
  // transformPlayer();
  new Waveform(canvas, callback);
}

function renderWaveforms() {



  //if(!isScrolling && !$("canvas.waveform:animated").length) {

    // Look for a corresponding element if a sound is playing
    //var canvas = $('canvas.waveform:not(.rendered, .queued):visible').get().reverse();
    var canvas = document.getElementsByClassName('waveform-cli')
    var i = canvas.length;

    if(i > 0) {
      // transformPlayer();
    }

    while(i--) {
      var nextElement = canvas[i];

      /*
      objThisId = jQuery(nextElement).data("track_id");



      if(jQuery(".track_canvas_" + objThisId).length > 1) {
        jQuery(".track_canvas_" + objThisId).last().parents("li").replaceWith(jQuery(".track_canvas_" + objThisId).first().parents("li"));
      }

      */

      //if (nextElement && nextElement.isOnScreen() && $(nextElement).is(":visible") && $(nextElement).parent().width() > 0) {
      if (nextElement) {
        //if(typeof window.sviewed === 'undefined') window.sviewed = [];
        //$nLi = $(nextElement).closest('li');
        //var tid = $nLi.data('mainid');
        //window.sviewed.push({id: tid, referer: ((typeof window.pageName==='undefined') ? false : window.pageName)});
        new Waveform(nextElement, renderWaveforms);
        //window.views.push(nextElement.closest('li').attr('data-id'));
        // $(nextElement).unbind("resize").resize(function(event) {
        //   $(this).removeClass('rendered');
        // });
      }
    }
}

// function transformPlayer() {
//   try {
//     var snd = false;
//     if(snd = findTrack()) {
//       if(!$('#'+snd.sID).length) {
//         // The original element where the sound is playing from
//         var currentPlayer = $(snd._data.oLI);
//         var currentWaveform = $(currentPlayer).find('.img_container > canvas');
//         var currentHighlight = $(snd._data.oPosition).find('.img > canvas');
//
//         // A new element containing the same track
//         var newPlayer = $('li[data-id='+$(currentPlayer).attr('data-id')+']:not(.sm2_playing, .sm2_paused)');
//
//         var newWaveform = $(newPlayer).find('.img_container > canvas'); // Should be there on loading
//         var newHighlight = $(newPlayer).find('.position > .img > canvas'); // May not be created now
//
//         var id = $(newPlayer).attr('id');
//         var classNames = $(newPlayer).attr('class');
//
//         if(newPlayer.length>0&&currentPlayer!=newPlayer) {
//           $(newWaveform).attr({position:$(currentWaveform).attr('position'),animate:false}).removeClass('rendered');
//           $(currentWaveform).remove();
//           $(currentHighlight).remove();
//           $(newWaveform).appendTo($(currentPlayer).find('.img_container'));
//           $(newHighlight).appendTo($(currentPlayer).find('.position > .img'));
//           $(currentPlayer).attr({'id':id,'class':classNames}).addClass((snd.paused)?'sm2_paused':'sm2_playing').insertAfter($(newPlayer));
//           $(newPlayer).remove();
//         }
//
//       }
//     }
//   } catch(e) {}
// }


function isAnimationReady(callback) {
  document.addEventListener("webkitAnimationStart", callback, false);
  document.addEventListener("mozAnimationStart", callback, false);
  document.addEventListener("oAnimationStart", callback, false);
  document.addEventListener("MSAnimationStart", callback, false);
  document.addEventListener("animationstart", callback, false);
}
window.onload = function () {
  renderWaveforms()
}
/**
 * Call Interval if document is ready
 */

// $(document).ready(function(){
//
//   if(location.hash=='#debug') {
//     $('<link/>').attr({rel:'stylesheet',type:'text/css',href:'/assets/_/js/generateWaveform.css'}).prependTo('head');
//     isAnimationReady(function(e){
//       if(e.animationName=='waveReady') {
//         /*
//         var canvas = $(e.target);
//         window.requestAnimFrame(function(){ renderWaveform(canvas); });
//         */
//         animationCount++;
//         if($('canvas.waveform:not(.rendered, .queued)').length==animationCount) {
//           window.requestAnimFrame(renderWaveforms);
//           animationCount = 0;
//         }
//       }
//     });
//
//     $('.waveform').resize(function(event) {
//       var canvas = $(this);
//       window.requestAnimFrame(function(){ renderWaveform(canvas); });
//     });
//   } else {
//     if(!window.waveWatcher) window.waveWatcher = window.setCustomInterval(renderWaveforms);
//     // Adjust blocks in waveform (if present) when resizing
//     /*
//     $('.waveform').resize(function(event) {
//       $(this).removeClass('rendered');
//     });
//     */
//   }
//
//   // User warning on unload if a track is currently playing
//   $(window).on("beforeunload",function(e) {
//     alert('beforeunload');
//     var trackLocal = getLocal("currentTrack");
//
//     if(trackLocal) {
//       if(parseInt(trackLocal.position,10) > 836000) {
//         var track = findTrack();
//         if(track) {
//           if(track.playState > 0 && !track.paused) {
//             return "A track is currently playing. Leave anyway?";
//           }
//         }
//       }
//
//     }
//   });
//
//
//   $(window).on('unload', function(){
//     alert('unload');
//     var track = findTrack();
//     if(track) {
//       if(track.playState > 0 && !track.paused) {
//         pause();
//         removeLocal("playing");
//       }
//     }
//   });
//
//   /* Resume Track */
//   var track = getLocal("currentTrack");
//   var isPlaying = getLocal("playing");
//   var playingStatus = jQuery.cookie("int_current_playing_status");
//   var ifPagesAreClosed = (getLocal('wc')==='true') ? true : false;
//   //alert('ifPagesAreClosed:' + ifPagesAreClosed);
//   setTimeout(function() {
//     if(!jQuery('body').hasClass('play') && track && playingStatus!='pause' && ifPagesAreClosed) {
//       //console.log("jQuery('body').hasClass('play'):" + jQuery('body').hasClass('play') + '|track.id:' + track.id + '|playingStatus:' + playingStatus);
//       if(jQuery('li[data-trackid=' + track.id + ']').length) {
//         jQuery('<li id="loading-buffer-box"><a href="javascript:void(0);" class="loading-buffer"><i class="fa fa-cog fa-spin fa-3x fa-fw"></i></a></li>').insertAfter('.micro-player .play_track');
//         jQuery('.micro-player .play_track, .micro-player .pause_track').css('display', 'none');
//         play(+track.id);
//         pause();
//         var ciV = setInterval(function() {
//           if(window.soundReady!=undefined && window.soundReady === 1) {
//             jQuery('#loading-buffer-box').css('display', 'none');
//             jQuery('.micro-player .play_track, .micro-player .pause_track').css('display', 'block');
//             findTrack(+track.id).setPosition(+track.position);
//             pagePlayer.getTime(+track.position, true)
//             var ct = pagePlayer.getTime(+track.position, true);
//             setTimeout(function() {
//               jQuery(".write_comment").attr("data-comment-position", Math.round(track.position / 1000));
//               jQuery(".comment_text").attr("placeholder", "Write comment at " + ct);
//               jQuery(".comment-placeholder").remove();
//             }, 500);
//             clearInterval(ciV);
//           }
//         }, 20);
//       } else if(jQuery('li[data-mainid=' + track.mainid + ']').length) {
//         jQuery('<li id="loading-buffer-box"><a href="javascript:void(0);" class="loading-buffer"><i class="fa fa-cog fa-spin fa-3x fa-fw"></i></a></li>').insertAfter('.micro-player .play_track');
//         jQuery('.micro-player .play_track, .micro-player .pause_track').css('display', 'none');
//         play(+track.mainid);
//         pause();
//         var ciV = setInterval(function() {
//           if(window.soundReady!=undefined && window.soundReady === 1) {
//             jQuery('#loading-buffer-box').css('display', 'none');
//             jQuery('.micro-player .play_track, .micro-player .pause_track').css('display', 'block');
//             findTrack(+track.mainid).setPosition(+track.position);
//             pagePlayer.getTime(+track.position, true)
//             var ct = pagePlayer.getTime(+track.position, true);
//             setTimeout(function() {
//               jQuery(".write_comment").attr("data-comment-position", Math.round(track.position / 1000));
//               jQuery(".comment_text").attr("placeholder", "Write comment at " + ct);
//               jQuery(".comment-placeholder").remove();
//             }, 500);
//             clearInterval(ciV);
//           }
//         }, 20);
//       } else {
//         getSound(+track.mainid);
//         var sIh = setInterval(function() {
//           if(!window.trackIsLoading) {
//             clearInterval(sIh);
//             jQuery('<li id="loading-buffer-box"><a href="javascript:void(0);" class="loading-buffer"><i class="fa fa-cog fa-spin fa-3x fa-fw"></i></a></li>').insertAfter('.micro-player .play_track');
//             jQuery('.micro-player .play_track, .micro-player .pause_track').css('display', 'none');
//             play(+track.mainid);
//             pause();
//             var ciV = setInterval(function() {
//               if(window.soundReady!=undefined && window.soundReady === 1) {
//                 jQuery('#loading-buffer-box').css('display', 'none');
//                 jQuery('.micro-player .play_track, .micro-player .pause_track').css('display', 'block');
//                 findTrack(+track.mainid).setPosition(+track.position);
//                 pagePlayer.getTime(+track.position, true)
//                 var ct = pagePlayer.getTime(+track.position, true);
//                 setTimeout(function() {
//                   jQuery(".write_comment").attr("data-comment-position", Math.round(track.position / 1000));
//                   jQuery(".comment_text").attr("placeholder", "Write comment at " + ct);
//                   jQuery(".comment-placeholder").remove();
//                 }, 500);
//                 clearInterval(ciV);
//               }
//             }, 20);
//           }
//         }, 10);
//       }
//     }
//   }, 3000);
//   window.wcInterval = setInterval(function() { jQuery.cookie('wc', 'false', {path: '/'}); storeLocal('wc', 'false'); }, 400);
//   if(track && !isPlaying && (jQuery(".content-layer").length == 0)) {
//     setTimeout(function() {
//       var trackobj = jQuery('li.track_' + track.id);
//       if(trackobj.length) {
//         /*
//         var tracktit = trackobj.data('playlist-title');
//         var trackurl = trackobj.find('a.player-link').attr('href');
//         var resumebox = jQuery('.h-resume');
//         resumebox.addClass('fadeIn show');
//         var resume = jQuery('#resume');
//         var playicon = jQuery('.play-icon');
//         var a = '<a rel="ajaxload" href="' + trackurl + '">' + tracktit + '</a>';
//         resume.html(a)
//         playicon.attr('onclick', 'play(+' + track.id + ');pause();setTimeout(function(){findTrack().setPosition(+'+track.position+');play();jQuery(".micro-player").find(".track_link").find(".gotocurrent").trigger("click"); jQuery(".h-resume").addClass("fadeOut")},1000); setTimeout(function() {jQuery(".h-resume").removeClass("show")}, 1500)')
//         /*
//         if(confirm("Resume Playback?")) {
//           play(+track.id);
//           pause();
//           setTimeout(function(){findTrack().setPosition(+track.position);play();jQuery(".micro-player").find(".track_link").find(".gotocurrent").trigger("click");},1000);
//         } else {
//           removeLocal("currentTrack");
//         }
//         */
//         play(+track.id);
//         pause();
//       } else {
//         getSound(+track.id, null, +track.id);
//         pause();
//       }
//     },3000);
//   }
// });

function updateValues(element) {
  var target = element || $('.waveform').first();
  var options = {
    animate:	false,
    blocks: 	$('#block').val()+','+$('#gap').val()+','+$('#average').is(':checked'),
    linear:		$('#linear').is(':checked'),
    normalize:	$('#normalize').is(':checked'),
    smooth:		$('#smooth').val(),
    align:		$('#align').val(),
    gradient:	$('#gradient').is(':checked'),
    color:		(pattern=/^url\((['"]?)(.*)\1\)$/.exec($('#color_colorSelector div').css('background-image')))?pattern[2]:$('#color_colorSelector div').css('background-color'),
    highlight:	(pattern=/^url\((['"]?)(.*)\1\)$/.exec($('#highlight_colorSelector div').css('background-image')))?pattern[2]:$('#highlight_colorSelector div').css('background-color'),
    alpha:		$('#alpha').val()
  }
  renderWaveform(target.attr(options).removeClass('rendered'));
}

function switchBgImage(element) {
  var url = prompt('URL eingeben...',(pattern=/^url\((['"]?)(.*)\1\)$/.exec($(element).css('background-image')))?pattern[2]:'http://');
  if(url&&url.match('^http://.*\.(jpg|png)$')) {
    $(element).css({'background':'url('+url+') no-repeat center center','background-size':'cover'});
    updateValues();
  }
}

function showWaveformControls(el) {
  var element = el || $('.waveform').first();
  $('.waveform_controls').remove();
  $('<style>.colorSelector_item {position: relative;width: 36px;height: 36px;background: url(/_/images/colorpicker/select.png);}.colorSelector_item div {position: absolute;top: 3px;left: 3px;width: 30px;height: 30px;background-size:cover!important}.waveform_controls{position: fixed; width: 300px; border-radius: 10px;background-color: rgba(255, 255, 255, 0.88);top: 70px;right: 220px;z-index: 10000;box-shadow: 0px 0px 8px rgba(0,0,0,0.7);padding: 20px;}.waveform_controls table{width:100%;margin:0;padding: 10px 0}.waveform_controls td{padding:0 10px}.row{pointer-events:none}</style>').appendTo('head');

  var options = {
    blocks: 	$(element).attr('blocks') || Waveform.prototype.blocks,
    linear:		$(element).attr('linear') || Waveform.prototype.linear,
    normalize:	$(element).attr('normalize') || Waveform.prototype.normalize,
    smooth:		$(element).attr('smooth') || Waveform.prototype.smooth,
    align:		$(element).attr('align') || Waveform.prototype.align,
    gradient:	$(element).attr('gradient') || Waveform.prototype.gradient,
    color:		$(element).attr('color') && $(element).attr('color').match('.*\.(jpg|png)$') ? 'url('+$(element).attr('color')+')' : $(element).attr('color') || Waveform.prototype.color,
    highlight:	$(element).attr('highlight') && $(element).attr('highlight').match('.*\.(jpg|png)$') ? 'url('+$(element).attr('highlight')+')' : $(element).attr('highlight') || Waveform.prototype.highlight,
    alpha:		$(element).attr('alpha') || Waveform.prototype.alpha
  }

  $('<div class="waveform_controls"><i onclick="hideWaveformControls()" class="fa fa-remove" style="float:right;cursor:pointer;color:#333"></i><h4>Waveform Controls</h4><table><tr><td><label>Color</label><div id="color_colorSelector" class="colorSelector_item"><div style="background:'+options.color+'"></div></div></td><td><label>Highlight</label><div id="highlight_colorSelector" class="colorSelector_item"><div style="background:'+options.highlight+'"></div></div></td><td><label>Gradient</label><input type="checkbox" id="gradient" onchange="updateValues()"'+(options.gradient?' checked="checked"':'')+'><label>Linear</label><input type="checkbox" id="linear" onchange="updateValues()"'+(options.linear?' checked="checked"':'')+'></td></tr><tr><td><button onclick="switchBgImage($(\'#color_colorSelector div\'))">Image...</button></td><td><button onclick="switchBgImage($(\'#highlight_colorSelector div\'))">Image...</button></td><td><label>Normalize</label><input type="checkbox" id="normalize" onchange="updateValues()"'+(options.normalize?'checked="checked"':'')+'></td></tr><tr><td colspan=3><label>Smooth</label><input type="range" min="0" max="50" value="'+options.smooth+'" id="smooth" onchange="updateValues()"></td></tr><tr><td colspan=2><label>Block Size</label><input type="range" min="0" max="20" value="0" step="1" id="block" onchange="updateValues()"></td><td><label>Digitize</label><input type="checkbox" id="average" checked="checked" onchange="updateValues()"></td></tr><tr><td colspan=3><label>Gap Size</label><input type="range" min="0" max="20" value="0" step="1" id="gap" onchange="updateValues()"></td></tr><tr><td colspan=3><label>Alpha</label><input type="range" min="0" max="1" value="'+options.alpha+'" step="0.1" id="alpha" onchange="updateValues()"></td></tr><tr><td colspan=3><label>Align</label><select id="align" onchange="updateValues()"><option value="top">Top</option><option value="center">Center</option><option value="bottom" selected="selected">Bottom</option></select></td></tr></table></div>').prependTo($(element).parents("li").first()).fadeIn(500);

  $('#color_colorSelector, #highlight_colorSelector').ColorPicker({
    color: '#ffffff',
    onShow: function (colpkr) {$(colpkr).fadeIn(500);return false},
    onHide: function (colpkr) {$(colpkr).fadeOut(500);return false},
    onChange: function (hsb, hex, rgb) {
      $($(this).data('colorpicker').el).find('div').css('background', '#' + hex);
      updateValues();
    }
  });

}




function setpixelated(context){
  context['imageSmoothingEnabled'] = false;       /* standard */
  context['mozImageSmoothingEnabled'] = false;    /* Firefox */
  context['oImageSmoothingEnabled'] = false;      /* Opera */
  context['webkitImageSmoothingEnabled'] = false; /* Safari */
  context['msImageSmoothingEnabled'] = false;     /* IE */

}


export default class WVF extends Waveform {}